export default __webpack_public_path__ + "static/media/D-DINCondensed.cedf3b66.ttf";